const CartNotificationOptions = {
    store,
    name: 'CartNotificationApp',
    delimiters: ['${', '}'],
    compilerOptions:{
        isCustomElement: tag => ['quantity-input', 'cart-remove-button'].includes(tag)
      },
    data() {
  
        let prueba = 'prueba'

            
        return {
            prueba,
            pruebaWidth: 20,
            code: '',
            note: '',
        }
  
    },
    computed: {
        getCurrencies(){

            return store.state.currency.allCurrencies

        },
        getCurrentCurrency(){

            return store.state.currency.allCurrencies.find(x=>x.currency == store.state.currency.current)

        },
        getDiscountProducto(){

            return store.state.totalDescuentoCodigo

        },
        showNote(){
            
            return store.state.cart?.data?.items.find(x=>x.sku == 'WU-PQ-INVC')

        },
        hasKits(){
            
            return store.state.cart?.data?.items.find(x=>x.sku.includes('PQ-'))

        },
        currentCode(){

            return store.state?.currentCode
        },
        timerCode(){
            // return {
            //     date: store.state?.timerCode?.date,
            //     code: store.state?.timerCode?.code,
            //     name: store.state?.currentCode?.currentCodigo?.name
            // }
            if(store.state?.timerCode?.date && store.state?.timerCode?.code == store.state?.currentCode?.currentCodigo?.name){

                return store.state?.timerCode?.date
            }
            // if(store.state?.timerCode?.date){

            //     let end = new Date(store.state?.timerCode?.date)
    
            //     if(new Date().valueOf() <= end.valueOf() ){
    
            //         return store.state?.timerCode
            //     }
            // }
            return
        },
        diasEnvio(){

            return store.state?.diasEnvio
        },
        getCurrentDsc(key){
            return store.state.customer.currentDsc
        },
        getCurrentDscFormatted(key){
            return store.state.customer.currentDscFormatted
        },
        getRewardDif(key){
            return store.state.nextRewardRemaining.difFormatted
        },
        getNextReward(){
            return store.state.nextRewardRemaining
        },
        getLastReward(){
            return store.state.lastReward
        },
        rewards(){
            return store.state.rewards
        },
        isWholesale(){
            return store.state.customer.isWholesale
        },
        cartItems(){
            return store.state.cart?.data?.items.map(x=>{

                return {
                    ...x,
                    title2: x.title.split(' - ')[0],
                    subtitle2: x.title.split(' - ')[1]?.split('|')[0] || '',
                }

            })
        },
        pastillero(){
            return store.state.cart.data?.items
            .filter(x=>x.product_type == 'BOTE' || x.product_type == 'PAQUETE')
            .map(x=>x.grams*x.quantity ).reduce((a,b)=>a+b,0)/1000 >= 4 && !store.state.customer.isWholesale
        },
        totalFormatted(){
            return Shopify.formatMoney(store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0))
        },
        total(){

            let totalReal = store.state.cart?.data?.items.map(item=>{
            
                const precio = (item.price )

                return ((item.price == 0 ? 0 : precio   )/100)*item.quantity
            
            }).reduce((a,b)=>a+b,0)*100

            return (store.state.customer.isWholesale ? totalReal : store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0))
        },
        totalReal(){
            let totalReal = store.state.cart?.data?.items.map(item=>{
            
                const precio = item.price

                return ((item.price == 0 ? 0 : precio )/100)*item.quantity
            
            }).reduce((a,b)=>a+b,0)*100

            const totalDiscounts = store.state.cart?.discounts?.reduce((a,b)=>a+b.amount,0)

            return store.state.customer.envio + (!store.state.customer.isWholesale ?  store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0)- store.state.customer.discountExtra : totalReal - store.state.customer.discountExtra) - totalDiscounts - store.state.customer.discountDistribuidor
        },
        discountExtra(){
            
            return store.state.customer.discountExtra
        },
        discountDistribuidor(){
            
            return store.state.customer.discountDistribuidor
        },
        discountExtraPercentage(){


						return store.state.customer.discountExtraText

        },
        envio(){
            
            return store.state.customer.envio

        },
        currentEnvio(){
            
            return store.state.customer.currentEnvio

        },
        formatMoney(value){

            return value ? Shopify.formatMoney(value) : ''
        },
        precioAlPublico(){
            const total = store.state.cart?.data?.total_price - store.state.cart?.discounts?.reduce((a,b)=>a+(b.amount || 0),0)
            
            return total
        },
        ganancia(){

            const total = store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0) - store.state.cart?.discounts?.reduce((a,b)=>a+(b.amount || 0),0)
            const totalReal = store.state.cart?.data?.items.map(item=>{
            
                const precio = (store.state.listaPrecios.find(x=>x.SKU == item.sku)?.Precio*100 || item.price)

                return ((item.price == 0 ? 0 : precio )/100)*item.quantity
            
            }).reduce((a,b)=>a+b,0)*100 - store.state.customer.discountExtra
            return Shopify.formatMoney(total-totalReal)

        },
        cartDiscounts(){
            return store.state.cart?.discounts
        },
        showAplicado(){
            return !store.state.cart?.discounts.every(x=>x.discountCode == false)
        },
        getDisabled() {

            let botes = store.state.cart?.data?.items
            .filter(x=>x.product_type == 'BOTE' || x.product_type == 'PAQUETE')
            .reduce((a,b)=>a+(b.grams*b.quantity),0)/1000

            let botesMinimo = store.state.cart?.data?.items
            .filter(x=>x.product_type == 'BOTE' || x.product_type == 'PAQUETE' || x.product_type == 'dist' )
            .reduce((a,b)=>a+(b.grams*b.quantity),0)/1000

            let botesMuestras = store.state.cart?.data?.items
            .filter(x=>x.product_type == 'MUESTRAS' )
            .reduce((a,b)=>a+(b.grams*b.quantity),0)/1000

            let minimoBotesWholesale = 16

            let minimo = store.state.customer.tags.includes('partner_regional_2022') ? 9999 : 349*8

            let totalReal = store.state.cart?.data?.items.map(item=>{
            
                const precio = item.price

                return ((item.price == 0 ? 0 : precio )/100)*item.quantity
            
            }).reduce((a,b)=>a+b,0)*100

            // (store.state.customer.puntos == 0 || store.state.customer.tags.includes('partner_regional_2022') )
            return  store.state.customer?.isWholesale &&  botesMinimo < minimoBotesWholesale || !(totalReal || botesMuestras)  
            
            let data = ((store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0)/100)*store.state.customer.discount )< store.state.wholesale?.config?.minimum_purchase
            return data && store.state.customer.isWholesale || !store.state.cart?.data?.items.length

        }
    },
    created() {

        store.dispatch('getCart',{}).then((result) => {
            // store.dispatch('finishLoading')
        }).catch((err) => {
        
        });
				
				store.dispatch('getCurrencyRates',{})
    },
    methods:{

        increaseQty(id, qty) {
            store.dispatch('increaseQty', {id, qty})
            .then((response) => {
    
            })
        },
        updateCart(id, qty) {
            store.dispatch('updateCart', {id, qty})
            .then((response) => {
    
            })
        },
        removeItem(id) {
          store.dispatch('updateCart', {id, qty: 0})
          .then((response) => {
  
          })
        },
        close(){
            store.dispatch('closeNotification')
            .then((response) => {
    
            })
        },
        crearDraftOrder(){
            

            if(this.getDisabled ){

                if(!store.state.cart.data.items.length){

                    Swal.fire({
                        title: '¡Ups!',
                        text: "No hay artículos en tu carrito..",
                        icon: 'warning',
                        // showCancelButton: true,
                        confirmButtonColor: '#a0ff7f',
                        // cancelButtonColor: '#454545',
                        // cancelButtonText:'Continuar comprando',
                        confirmButtonText: 'Continuar comprando'
                    })
                }else{
                    Swal.fire({
                        title: '¡Ups!',
                        text: "Debes cumplir con el mínimo de compra para poder continuar.",
                        icon: 'warning',
                        // showCancelButton: true,
                        confirmButtonColor: '#a0ff7f',
                        // cancelButtonColor: '#454545',
                        // cancelButtonText:'Continuar comprando',
                        confirmButtonText: 'Continuar comprando'
                    })
                }
                return
            }
                        // this.pruebas()
                        // const submitButtons = document.querySelectorAll(`.cart-notification__links .button`)
                        // const overlays = document.querySelectorAll(`.cart-notification__links .loading-overlay__spinner`)
                        
                        // submitButtons.forEach(x=>{
                        
                        //     x.setAttribute('aria-disabled', true);
                        //     x.classList.add('loading');
              
                  
                        // })
                        // overlays.forEach(x=>x.classList.remove('hidden'))
            if(!store.state.customer.isWholesale && new Date().valueOf() < new Date('2022-01-19T00:00-06:00').valueOf()  ){
                // Swal.fire
            }else{

            }

            if(!store.state.customer.isWholesale){
                if(store.state.cart.data.items.some(x=>x.selling_plan_allocation)){

                    window.location.href = '/checkout'

                }else {

                    store.dispatch('createDraftOrderRetail', this.note)
                    // .then((response2) => {
                        
                    // })

                }
                return
            }else{
                
                store.dispatch('createDraftOrderWholesale', this.note)
                .then((response2) => {
                    
                })
            }

            // if(store.state.customer.isWholesale){

            // }else{
            //     Swal.fire({
            //         icon: 'error',
            //         title: '¡Ups!',
            //         text: 'La preventa es exclusiva para distribuidores',
            //         confirmButtonText: 'Volver a intentar',
            //         confirmButtonColor:'#a0ff7f',
            //         footer: `
            //         <div class="text-body flex-column">
            //             <a class="button" href="/account/login">Iniciar sesión</a>
            //             <span class="mt-10px">
            //             Si ya eres distribuidor Come Verde, <a href="https://registro.comeverde.mx/distribuidor">activa tu cuenta aquí</a>
            //             </span>
            //         </div>
            //         `
            //       })
            // }

        },
        checkout(){

            if(store.state.cart?.data?.items.find(x=> ['PQ-INV'].includes(x.sku) ) && !store.state.customer?.isWholesale ){
                Swal.fire({
                    title: '¡Atención!',
                    icon: 'warning',
                    html:
                      `<span class="" >
                        <b>
                          ⚠️Hay productos en tu carrito que son exclusivos para distribuidor
                          </b>
                        <br>
                        <br>
                        Para poder comprarlos debes inciar sesión como distribuidor.😥
                      </span>
                      `,
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: true,
                    cancelButtonText:'Quitar productos',
                    confirmButtonText:'Ingresar a mi cuenta',
                    confirmButtonColor: '#a0ff7f',
                }).then((result) => {
                    
                    if (result.value ) {
                      window.location.href = "/account/login"
                    }else if (result.dismiss == 'cancel'){
                        
                        store.state.cart.data.items.filter(x=> ['PQ-DIST1.1','PQ-TND'].includes(x.sku) ).map(x=>{
                                                        
                            this.updateCart(x.id,0)

                        })
                    }
                })

                return
            }

            const total = store.state.cart.data.items.map(x=>{
                
                return (x.price/100)*x.quantity
            
            }).reduce((a,b)=>a+b,0)

            const botes = store.state.cart.data.items
                .filter(x=>x.product_type == 'BOTE' || x.product_type == 'PAQUETE')
                .map(x=>x.grams*x.quantity ).reduce((a,b)=>a+b,0)/1000

            if(!store.state.customer.isCustomer && botes > 16){

                    Swal.fire({
                        title: '¡Atención!',
                        icon: 'warning',
                        html:
                          `<span class="" >
                            <b>
                              ⚠️No estás en tu cuenta, ¿seguro que quieres continuar?
                              </b>
                            <br>
                            <br>
                            Si tienes descuento de distribuidor, no se te aplicará. 😥
                          </span>
                          `,
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: true,
                        cancelButtonText:'Sí, quiero continuar',
                        confirmButtonText:'Ingresar a mi cuenta',
                        confirmButtonColor: '#a0ff7f',
                      }).then((result) => {

                        
                        if (result.value ) {
                          window.location.href = "/account/login"
                        }else if( result.dismiss == 'cancel'){
                            this.crearDraftOrder()
                        }
                      })

            }else{
                this.crearDraftOrder()
            }
        },
        checarCodigoEspecial(){

            const submitButton = document.querySelector(`#buttonChecarCodigoEspecial`)
            const overlay = document.querySelector(`#buttonChecarCodigoEspecial .loading-overlay__spinner`)

            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('loading');

            overlay.classList.remove('hidden');

            store.dispatch('getChecarCodigoEspecial',{ codigo: this.code  })
        },
        checarCodigoEspecialDist(){

            const submitButton = document.querySelector(`#buttonChecarCodigoEspecial`)
            const overlay = document.querySelector(`#buttonChecarCodigoEspecial .loading-overlay__spinner`)

            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('loading');

            overlay.classList.remove('hidden');

            store.dispatch('getChecarCodigoEspecialDist',{ codigo: this.code  })
        },
        quitarCodigoEspecial(){

            store.dispatch('quitarCodigoEspecial')
        },
    }

}

const CartNotificationApp = Vue.createApp(CartNotificationOptions)

mountVueComponent(CartNotificationApp, 'custom-price')


CartNotificationApp.mount('.cart-notification-wrapper')
CartNotificationApp.use(store)


const CartBubbleOptions = {
    store,
    name: 'CartBubbleApp',
    delimiters: ['${', '}'],
    data() {
        
        return {

        }

    },
    computed: {
        numItems(){
            return store.state.cart?.data?.item_count
        },
        totalFormatted(){
            return Shopify.formatMoney(store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0))
        },
        total(){
            return store.state.cart?.data?.items.map(item=>{
            
                return (item.price)*item.quantity
            
            }).reduce((a,b)=>a+b,0)
        },
        currentNivel(){
            return store.state.wholesale?.current
        },

    },
    created() {
        

    },
    methods:{
        openNotification(){
            store.dispatch('openNotification')
          .then((response) => {
  
          })
        }
    }

}

const CartBubbleApp = Vue.createApp(CartBubbleOptions)
CartBubbleApp.mount('#CartBubbleApp')
CartBubbleApp.use(store)


const FooterOptions = {
    store,
    name: 'FooterApp',
    delimiters: ['${', '}'],
    data() {
        
        return {

        }

    },
    computed: {
        numItems(){
            return store.state.cart?.data?.item_count
        },
				getCurrencies(){

					return store.state.currency.allCurrencies

				},
				getCurrentCurrency(){

						return store.state.currency.allCurrencies.find(x=>x.currency == store.state.currency.current)

				},

    },
    created() {
        

    },
    methods:{

    }

}


const FooterApp = Vue.createApp(FooterOptions)
FooterApp.mount('#FooterApp')
FooterApp.use(store)

const HeaderDrawerOptions = {
    store,
    name: 'FooterApp',
    delimiters: ['${', '}'],
    data() {
        
        return {

        }

    },
    computed: {
        numItems(){
            return store.state.cart?.data?.item_count
        },
				getCurrencies(){

					return store.state.currency.allCurrencies

				},
				getCurrentCurrency(){

						return store.state.currency.allCurrencies.find(x=>x.currency == store.state.currency.current)

				},

    },
    created() {
        

    },
    methods:{

    }

}
const HeaderDrawerApp = Vue.createApp(HeaderDrawerOptions)
HeaderDrawerApp.mount('#HeaderDrawerApp')
HeaderDrawerApp.use(store)
